<script setup lang="ts">
  import { computed } from 'vue';
  import type { CaslAction, Subjects } from '@/shared/lib/casl';
  import { checkPermissions, type PermissionMatchMode } from '@/shared/lib';
  import { usePermission } from '../model/usePermission';

  const props = withDefaults(
    defineProps<{
      permissions: { action: CaslAction; subject: Subjects }[];
      fallback?: 'hide' | 'disable' | 'slot';
      matchMode?: PermissionMatchMode;
    }>(),
    { fallback: 'hide', matchMode: 'all' }
  );

  const { can } = usePermission();
  const hasPermission = computed(() =>
    checkPermissions(
      props.permissions,
      ({ action, subject }) => can(action, subject).value,
      props.matchMode,
    )
  );
</script>

<template>
  <template v-if="hasPermission">
    <slot />
  </template>
  <template v-else>
    <template v-if="fallback === 'disable'">
      <div class="opacity-50 pointer-events-none">
        <slot />
      </div>
    </template>
    <template v-else-if="fallback === 'slot'">
      <slot name="fallback" />
    </template>
  </template>
</template>
